/* <ap-countdown end="ISO datetime"> with [data-d][data-h][data-m][data-s] children */
class ApCountdown extends HTMLElement {
  connectedCallback() {
    this.end = new Date(this.getAttribute('end')).getTime();
    this.parts = {
      d: this.querySelector('[data-d]'),
      h: this.querySelector('[data-h]'),
      m: this.querySelector('[data-m]'),
      s: this.querySelector('[data-s]'),
    };
    if (isNaN(this.end)) return;
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }
  disconnectedCallback() {
    clearInterval(this.timer);
  }
  tick() {
    let diff = Math.max(0, this.end - Date.now());
    const pad = (n) => String(n).padStart(2, '0');
    const d = Math.floor(diff / 864e5);
    diff -= d * 864e5;
    const h = Math.floor(diff / 36e5);
    diff -= h * 36e5;
    const m = Math.floor(diff / 6e4);
    diff -= m * 6e4;
    const s = Math.floor(diff / 1e3);
    if (this.parts.d) this.parts.d.textContent = pad(d);
    if (this.parts.h) this.parts.h.textContent = pad(h);
    if (this.parts.m) this.parts.m.textContent = pad(m);
    if (this.parts.s) this.parts.s.textContent = pad(s);
    if (this.end - Date.now() <= 0) clearInterval(this.timer);
  }
}
customElements.define('ap-countdown', ApCountdown);
